<template lang="pug">
  div
    doc-markdown(source=`
    ## Radio \`sw-radio\`
    `)

    doc-preview(vue=`
    sw-radio(
      v-for="option in availableOptions"
      :key="option"
      v-model="chosenOption"
      :radio-value="option"
      custom-classes="flex max-w-xs rounded border border-green-200 py-3 my-3"
      radio-classes="w-6 h-6 p-3 mx-3 flex items-center justify-center rounded-full border border-green-900"
      checked-radio-classes="w-4 h-4 p-2 mx-3 rounded-full checked:bg-green-900"
    )
      span(v-text="option")

    <script>
      ...
      data() {
        return {
          chosenOption: '',
          availableOptions: ['Option One', 'Option Two']
        }
      }
    </script>
    `)
      sw-radio(
        v-for="option in availableOptions"
        :key="option"
        v-model="chosenOption"
        :radio-value="option"
        custom-classes="flex max-w-xs rounded border border-green-200 py-3 my-3"
        radio-classes="w-6 h-6 p-3 mx-3 flex items-center justify-center rounded-full border border-green-900"
        checked-radio-classes="w-4 h-4 p-2 mx-3 rounded-full checked:bg-green-900"
      )
        span(v-text="option")

    doc-markdown(source=`
    ### Slots
  | Slot name      | Description |
  |----------------|-------------|
  | *default*      | The label   |
    `)

    doc-markdown(source=`
    ### Properties
  | Props                       | Description                                                           | Type                    | Default |
  |-----------------------------|-----------------------------------------------------------------------|-------------------------|---------|
  | \`value\`  (v-model)        | Chosen value to which the radios are binded.                          | String, Boolean, Number | -       |
  | \`radio-value\`             | Value of specific radio item.                                         | String, Boolean, Number | -       |
  | \`custom-classes\`          | Classes wrapping the whole component.                                 | String                  | -       |
  | \`radio-classes\`           | Classes applied on the check-"box" part of the component.             | String                  | -       |
  | \`checked-radio-classes\`   | Classes applied on the check-"box" part of the component when checked.| String                  | -       |
    `)

    doc-markdown(id="events" source=`
    ### Events
  | Event name | Description            | Parameters    | Usage      |
  |------------|------------------------|:-------------:|------------|
  | click      | Triggered when clicked | \`radioValue\`| \`@click\` |
    `)
</template>

<script>
  export default {
    data () {
      return {
        chosenOption: '',
        availableOptions: ['Option One', 'Option Two'],
      };
    },
  };
</script>
